__turbopack_context__.v({
  "default": "_2I9rXa_default",
  "downloadBtn": "_2I9rXa_downloadBtn",
  "dynamicList": "_2I9rXa_dynamicList",
  "dynamicMenu": "_2I9rXa_dynamicMenu",
  "menuActions": "_2I9rXa_menuActions",
  "offCanvasEnabled": "_2I9rXa_offCanvasEnabled",
});
